/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateTuitionRatePlanRequest,
  CreateTuitionRatePlanResponse,
  CreateTuitionRateTierRequest,
  CreateTuitionRateTierResponse,
  GetTuitionRatePlanResponse,
  Result,
  UpdateTuitionRatePlanRequest,
  UpdateTuitionRatePlanResponse,
  UpdateTuitionRateTierRequest,
  UpdateTuitionRateTierResponse,
} from '../models/index';
import {
    CreateTuitionRatePlanRequestFromJSON,
    CreateTuitionRatePlanRequestToJSON,
    CreateTuitionRatePlanResponseFromJSON,
    CreateTuitionRatePlanResponseToJSON,
    CreateTuitionRateTierRequestFromJSON,
    CreateTuitionRateTierRequestToJSON,
    CreateTuitionRateTierResponseFromJSON,
    CreateTuitionRateTierResponseToJSON,
    GetTuitionRatePlanResponseFromJSON,
    GetTuitionRatePlanResponseToJSON,
    ResultFromJSON,
    ResultToJSON,
    UpdateTuitionRatePlanRequestFromJSON,
    UpdateTuitionRatePlanRequestToJSON,
    UpdateTuitionRatePlanResponseFromJSON,
    UpdateTuitionRatePlanResponseToJSON,
    UpdateTuitionRateTierRequestFromJSON,
    UpdateTuitionRateTierRequestToJSON,
    UpdateTuitionRateTierResponseFromJSON,
    UpdateTuitionRateTierResponseToJSON,
} from '../models/index';

export interface ApiTuitionTiersRatePlansGetRequest {
    includeTiers?: boolean;
    onlyActive?: boolean;
    xTenantID?: number;
}

export interface ApiTuitionTiersRatePlansIdDeleteRequest {
    id: number;
    xTenantID?: number;
}

export interface ApiTuitionTiersRatePlansIdGetRequest {
    id: number;
    xTenantID?: number;
}

export interface ApiTuitionTiersRatePlansIdPutRequest {
    id: number;
    updateTuitionRatePlanRequest: UpdateTuitionRatePlanRequest;
    xTenantID?: number;
}

export interface ApiTuitionTiersRatePlansPlanIdTiersDeleteRequest {
    planId: number;
    xTenantID?: number;
}

export interface ApiTuitionTiersRatePlansPlanIdTiersPostRequest {
    planId: number;
    createTuitionRateTierRequest: CreateTuitionRateTierRequest;
    xTenantID?: number;
}

export interface ApiTuitionTiersRatePlansPlanIdTiersTierIdDeleteRequest {
    planId: number;
    tierId: number;
    xTenantID?: number;
}

export interface ApiTuitionTiersRatePlansPlanIdTiersTierIdPutRequest {
    planId: number;
    tierId: number;
    updateTuitionRateTierRequest: UpdateTuitionRateTierRequest;
    xTenantID?: number;
}

export interface ApiTuitionTiersRatePlansPostRequest {
    createTuitionRatePlanRequest: CreateTuitionRatePlanRequest;
    xTenantID?: number;
}

/**
 * 
 */
export class TuitionTiersApi extends runtime.BaseAPI {

    /**
     * Get tuition rate plans.
     * Get tuition rate plans
     */
    async apiTuitionTiersRatePlansGetRaw(requestParameters: ApiTuitionTiersRatePlansGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetTuitionRatePlanResponse>>> {
        const queryParameters: any = {};

        if (requestParameters['includeTiers'] != null) {
            queryParameters['includeTiers'] = requestParameters['includeTiers'];
        }

        if (requestParameters['onlyActive'] != null) {
            queryParameters['onlyActive'] = requestParameters['onlyActive'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/tuition-tiers/rate-plans`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetTuitionRatePlanResponseFromJSON));
    }

    /**
     * Get tuition rate plans.
     * Get tuition rate plans
     */
    async apiTuitionTiersRatePlansGet(requestParameters: ApiTuitionTiersRatePlansGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetTuitionRatePlanResponse>> {
        const response = await this.apiTuitionTiersRatePlansGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete tuition rate plan by id.
     * Delete tuition rate plan
     */
    async apiTuitionTiersRatePlansIdDeleteRaw(requestParameters: ApiTuitionTiersRatePlansIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiTuitionTiersRatePlansIdDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/tuition-tiers/rate-plans/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete tuition rate plan by id.
     * Delete tuition rate plan
     */
    async apiTuitionTiersRatePlansIdDelete(requestParameters: ApiTuitionTiersRatePlansIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiTuitionTiersRatePlansIdDeleteRaw(requestParameters, initOverrides);
    }

    /**
     * Get tuition rate plan by id.
     * Get tuition rate plan
     */
    async apiTuitionTiersRatePlansIdGetRaw(requestParameters: ApiTuitionTiersRatePlansIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetTuitionRatePlanResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiTuitionTiersRatePlansIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/tuition-tiers/rate-plans/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetTuitionRatePlanResponseFromJSON(jsonValue));
    }

    /**
     * Get tuition rate plan by id.
     * Get tuition rate plan
     */
    async apiTuitionTiersRatePlansIdGet(requestParameters: ApiTuitionTiersRatePlansIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetTuitionRatePlanResponse> {
        const response = await this.apiTuitionTiersRatePlansIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update an existing tuition rate plan.
     * Update tuition rate plan
     */
    async apiTuitionTiersRatePlansIdPutRaw(requestParameters: ApiTuitionTiersRatePlansIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdateTuitionRatePlanResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiTuitionTiersRatePlansIdPut().'
            );
        }

        if (requestParameters['updateTuitionRatePlanRequest'] == null) {
            throw new runtime.RequiredError(
                'updateTuitionRatePlanRequest',
                'Required parameter "updateTuitionRatePlanRequest" was null or undefined when calling apiTuitionTiersRatePlansIdPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/tuition-tiers/rate-plans/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateTuitionRatePlanRequestToJSON(requestParameters['updateTuitionRatePlanRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpdateTuitionRatePlanResponseFromJSON(jsonValue));
    }

    /**
     * Update an existing tuition rate plan.
     * Update tuition rate plan
     */
    async apiTuitionTiersRatePlansIdPut(requestParameters: ApiTuitionTiersRatePlansIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdateTuitionRatePlanResponse> {
        const response = await this.apiTuitionTiersRatePlansIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete all tuition rate tiers for a plan.
     * Delete tuition rate tiers by plan
     */
    async apiTuitionTiersRatePlansPlanIdTiersDeleteRaw(requestParameters: ApiTuitionTiersRatePlansPlanIdTiersDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['planId'] == null) {
            throw new runtime.RequiredError(
                'planId',
                'Required parameter "planId" was null or undefined when calling apiTuitionTiersRatePlansPlanIdTiersDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/tuition-tiers/rate-plans/{planId}/tiers`;
        urlPath = urlPath.replace(`{${"planId"}}`, encodeURIComponent(String(requestParameters['planId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete all tuition rate tiers for a plan.
     * Delete tuition rate tiers by plan
     */
    async apiTuitionTiersRatePlansPlanIdTiersDelete(requestParameters: ApiTuitionTiersRatePlansPlanIdTiersDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiTuitionTiersRatePlansPlanIdTiersDeleteRaw(requestParameters, initOverrides);
    }

    /**
     * Create a new tuition rate tier.
     * Create tuition rate tier
     */
    async apiTuitionTiersRatePlansPlanIdTiersPostRaw(requestParameters: ApiTuitionTiersRatePlansPlanIdTiersPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateTuitionRateTierResponse>> {
        if (requestParameters['planId'] == null) {
            throw new runtime.RequiredError(
                'planId',
                'Required parameter "planId" was null or undefined when calling apiTuitionTiersRatePlansPlanIdTiersPost().'
            );
        }

        if (requestParameters['createTuitionRateTierRequest'] == null) {
            throw new runtime.RequiredError(
                'createTuitionRateTierRequest',
                'Required parameter "createTuitionRateTierRequest" was null or undefined when calling apiTuitionTiersRatePlansPlanIdTiersPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/tuition-tiers/rate-plans/{planId}/tiers`;
        urlPath = urlPath.replace(`{${"planId"}}`, encodeURIComponent(String(requestParameters['planId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateTuitionRateTierRequestToJSON(requestParameters['createTuitionRateTierRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateTuitionRateTierResponseFromJSON(jsonValue));
    }

    /**
     * Create a new tuition rate tier.
     * Create tuition rate tier
     */
    async apiTuitionTiersRatePlansPlanIdTiersPost(requestParameters: ApiTuitionTiersRatePlansPlanIdTiersPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateTuitionRateTierResponse> {
        const response = await this.apiTuitionTiersRatePlansPlanIdTiersPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete tuition rate tier by id.
     * Delete tuition rate tier
     */
    async apiTuitionTiersRatePlansPlanIdTiersTierIdDeleteRaw(requestParameters: ApiTuitionTiersRatePlansPlanIdTiersTierIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['planId'] == null) {
            throw new runtime.RequiredError(
                'planId',
                'Required parameter "planId" was null or undefined when calling apiTuitionTiersRatePlansPlanIdTiersTierIdDelete().'
            );
        }

        if (requestParameters['tierId'] == null) {
            throw new runtime.RequiredError(
                'tierId',
                'Required parameter "tierId" was null or undefined when calling apiTuitionTiersRatePlansPlanIdTiersTierIdDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/tuition-tiers/rate-plans/{planId}/tiers/{tierId}`;
        urlPath = urlPath.replace(`{${"planId"}}`, encodeURIComponent(String(requestParameters['planId'])));
        urlPath = urlPath.replace(`{${"tierId"}}`, encodeURIComponent(String(requestParameters['tierId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete tuition rate tier by id.
     * Delete tuition rate tier
     */
    async apiTuitionTiersRatePlansPlanIdTiersTierIdDelete(requestParameters: ApiTuitionTiersRatePlansPlanIdTiersTierIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiTuitionTiersRatePlansPlanIdTiersTierIdDeleteRaw(requestParameters, initOverrides);
    }

    /**
     * Update an existing tuition rate tier.
     * Update tuition rate tier
     */
    async apiTuitionTiersRatePlansPlanIdTiersTierIdPutRaw(requestParameters: ApiTuitionTiersRatePlansPlanIdTiersTierIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdateTuitionRateTierResponse>> {
        if (requestParameters['planId'] == null) {
            throw new runtime.RequiredError(
                'planId',
                'Required parameter "planId" was null or undefined when calling apiTuitionTiersRatePlansPlanIdTiersTierIdPut().'
            );
        }

        if (requestParameters['tierId'] == null) {
            throw new runtime.RequiredError(
                'tierId',
                'Required parameter "tierId" was null or undefined when calling apiTuitionTiersRatePlansPlanIdTiersTierIdPut().'
            );
        }

        if (requestParameters['updateTuitionRateTierRequest'] == null) {
            throw new runtime.RequiredError(
                'updateTuitionRateTierRequest',
                'Required parameter "updateTuitionRateTierRequest" was null or undefined when calling apiTuitionTiersRatePlansPlanIdTiersTierIdPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/tuition-tiers/rate-plans/{planId}/tiers/{tierId}`;
        urlPath = urlPath.replace(`{${"planId"}}`, encodeURIComponent(String(requestParameters['planId'])));
        urlPath = urlPath.replace(`{${"tierId"}}`, encodeURIComponent(String(requestParameters['tierId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateTuitionRateTierRequestToJSON(requestParameters['updateTuitionRateTierRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpdateTuitionRateTierResponseFromJSON(jsonValue));
    }

    /**
     * Update an existing tuition rate tier.
     * Update tuition rate tier
     */
    async apiTuitionTiersRatePlansPlanIdTiersTierIdPut(requestParameters: ApiTuitionTiersRatePlansPlanIdTiersTierIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdateTuitionRateTierResponse> {
        const response = await this.apiTuitionTiersRatePlansPlanIdTiersTierIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a new tuition rate plan.
     * Create tuition rate plan
     */
    async apiTuitionTiersRatePlansPostRaw(requestParameters: ApiTuitionTiersRatePlansPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateTuitionRatePlanResponse>> {
        if (requestParameters['createTuitionRatePlanRequest'] == null) {
            throw new runtime.RequiredError(
                'createTuitionRatePlanRequest',
                'Required parameter "createTuitionRatePlanRequest" was null or undefined when calling apiTuitionTiersRatePlansPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/tuition-tiers/rate-plans`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateTuitionRatePlanRequestToJSON(requestParameters['createTuitionRatePlanRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateTuitionRatePlanResponseFromJSON(jsonValue));
    }

    /**
     * Create a new tuition rate plan.
     * Create tuition rate plan
     */
    async apiTuitionTiersRatePlansPost(requestParameters: ApiTuitionTiersRatePlansPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateTuitionRatePlanResponse> {
        const response = await this.apiTuitionTiersRatePlansPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
